import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Backdrop,
    Button,
    CircularProgress,
    Grid,
    Typography
} from '@material-ui/core';
import {Stack, Checkbox} from '@mui/material';
import React, {useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {useFirestoreConnect, isLoaded} from 'react-redux-firebase'
import {toDateTime} from '../../shared/functions/toDateTime'
import {Fragment} from 'react'
import {closeReceivingAction, DefinitifCloseShipping} from '../../redux/actions/receiving/action'
import useNotificationDialog from '../../shared/components/useNotificationDialog'
import {Alert} from '@material-ui/lab'
import useInReceivingDetails from './../receiving/InReceivingDetails';
import ShippedDetails from './../receiving/ShippedDetails';
import ReceivingResume from './../receiving/ReceivingResume';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ReceivingCard from './../receiving/ReceivingCard';
import {useCreateReceivingDialog} from '../receiving/Shipped';
import {RECEIVED_TYPES} from '../../shared/constants/receivedType'
import {useReceivingContext} from './../receiving/Receivingtab';
import {reverseReceivingArchiving} from "../../redux/slices/receiving";
import {LoadingButton} from "@mui/lab";
import {gfDate} from "../../utils/formatTime";


const ReceivedGroup = ({ShippingId, Receiving, expanded, handleChange, receivingType = null, archiveMod = false}) => {

    const {Ids, selectedReceiving, setSeletectRepport} = useReceivingContext();

    const [select, setSelect] = React.useState(null)
    const [canCreate, setCanCreate] = React.useState(true)

    const [resumeOpen, setResumeOpen] = React.useState(false);

    const [ShippedLoading, setShippedLoading] = React.useState(false)
    const [openShippingDetails, setopenShippingDetails] = React.useState(false)
    const actionDispatch = useDispatch()

    const {open, handleClickOpen, InReceivingDetails} = useInReceivingDetails()

    useFirestoreConnect(() => [
        {collection: 'shipping_orders', doc: ShippingId, storeAs: 'getShippedDetails'}
    ])


    const handleSelectChecked = (e, id) => {
        selectedReceiving(Receiving,);
        if (e.target.checked) {
            return setSeletectRepport([...Ids, id]);
        }

        return setSeletectRepport(Ids.filter(_id => _id !== id));
    }

    const ShippingOrder = useSelector(state => state.firestore.ordered['getShippedDetails'])


    const {ShowCreateForm, creatHandleOpen, createOpen, handleclose} = useCreateReceivingDialog();

    const {
        ShowNotificationDialog,
        handleClose,
        handleOpen: handleOpenCloseShipping,
        open: closeShipping
    } = useNotificationDialog()

    const isLoading = useSelector(state => state.receiving.isLoading)

    React.useEffect(() => {
        if (Receiving !== null) {
            const exist = Receiving.find(it => it?.isOpen === true);

            if (exist) {
                setCanCreate(false)
            } else {
                setCanCreate(true)
            }
        }

        if (!isLoaded(ShippingOrder)) {
            setShippedLoading(true)
        } else {
            setShippedLoading(false)
        }
    }, [Receiving, ShippingOrder])


    const handleCloseResume = () => {
        setResumeOpen(false);
    }

    const handleOpen = (recpt) => {
        setSelect(recpt)
        handleClickOpen()
    }


    const handleOpenShippingDetails = () => {
        setopenShippingDetails(true)
    }

    const handleCloseShippingDetails = () => {
        setopenShippingDetails(false)
    }

    const createHandleclick = () => {
        creatHandleOpen && creatHandleOpen({
            id: ShippingId,
            ContainerCode: Receiving[0].ContainerCode,
        })
    }


    const handleCloseReceiving = React.useCallback((receivingId) => {
        actionDispatch(closeReceivingAction({ShippingId, receivingId}))
        handleclose()
    }, [ShippingId, actionDispatch, handleclose])


    const handleDefinitiveClose = () => {
        actionDispatch(DefinitifCloseShipping({ShippingId: ShippingId, callback: handleClose}))
    }

    const [aLoading, setALoading] = useState(false);

    const handleUnArchive = () => {
        setALoading(true)
        actionDispatch(reverseReceivingArchiving(Receiving, () => setALoading(false)))
    }

    return (
        <Grid item xs={12} sm={12}>
            {
                createOpen && <ShowCreateForm/>
            }
            {
                closeShipping && <ShowNotificationDialog title="Fermeture definitive du contenaire" action={
                    <Fragment>
                        <Button variant="text" color="secondary" onClick={handleClose}> Annuler </Button>
                        {" "}
                        <Button variant="text" color="primary" onClick={handleDefinitiveClose}>
                            {isLoading ? <CircularProgress size={20}/> : "Cloturer"} </Button>
                    </Fragment>
                }>
                    <Fragment>
                        <Alert severity="warning"> Vous êtes certaine de fermer ce contenaire ? </Alert>
                        {isLoading && <Backdrop open={isLoading}> <CircularProgress size={40}/> </Backdrop>}
                    </Fragment>
                </ShowNotificationDialog>
            }
            {
                openShippingDetails && !ShippedLoading &&

                (ShippingOrder !== null && ShippingOrder.length > 0) &&
                <ShippedDetails items={Receiving[0]} open={openShippingDetails}
                                onClose={handleCloseShippingDetails}/>
            }
            {open && select !== null && <InReceivingDetails Receiving={select} ShippingId={ShippingId}/>}


            {resumeOpen &&
                <ReceivingResume Receivings={Receiving} ShippingOrder={ShippingOrder} handleClose={handleCloseResume}/>}

            <Stack direction="row">
                <Checkbox onChange={(e) => handleSelectChecked(e, ShippingId)}/>
                <Accordion style={{width: '100%'}} expanded={expanded === ShippingId}
                           onChange={handleChange(ShippingId)}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon/>}
                        aria-controls="panel1bh-content"
                        id="panel1bh-header">

                        <Grid container>
                            <Typography> {`Container code :   "${Receiving[0].ContainerCode}" - Créé le ${gfDate(Receiving[0]?.CreateAt)}`} </Typography>
                        </Grid>

                    </AccordionSummary>
                    <AccordionDetails>
                        <Grid container spacing={1}>

                            <Grid container item style={{marginBottom: 30}}>

                                <Stack direction="row" sx={{overflowY: 'hidden'}} spacing={2}>
                                    <Button onClick={handleOpenShippingDetails}
                                            style={{backgroundColor: 'orange', fontWeight: 'bold'}}
                                            variant="contained"> Détails du contenaire </Button>


                                    <Button onClick={() => setResumeOpen(true)}
                                            style={{
                                                backgroundColor: 'green',
                                                fontWeight: 'bold', color: 'white'
                                            }}
                                            variant="contained">
                                        Résumé des Reception
                                    </Button>

                                    {receivingType === RECEIVED_TYPES.IN_RECEIVING &&
                                        <Button disabled={!canCreate} onClick={createHandleclick}
                                                color="primary" variant="contained">
                                            Nouvelle Reception </Button>
                                    }

                                    {
                                        archiveMod && (
                                            <LoadingButton loading={aLoading} onClick={handleUnArchive}
                                                           color="primary" variant="contained">
                                                Retirer des archives
                                            </LoadingButton>
                                        )
                                    }


                                    {receivingType === RECEIVED_TYPES.IN_RECEIVING &&
                                        <Button disabled={!canCreate}
                                                onClick={handleOpenCloseShipping}
                                                color="secondary" style={{fontWeight: 'bold'}}
                                                variant="contained"> cloture la reception </Button>
                                    }

                                </Stack>


                            </Grid>

                            <Grid container item xs={12} sm={12} spacing={1}>
                                {Receiving.map((rec, idx) => {
                                    return <Grid key={idx} item xs={12} md={3} sm={6}>
                                        <ReceivingCard
                                            titile={"Créé le : " + toDateTime(rec.CreateAt.seconds).toLocaleString()}
                                            content={
                                                <Fragment>
                                                    <Typography> {"Par : " + rec.UserName} </Typography>
                                                    {rec.Note && <Typography> {"Note : " + rec.Note} </Typography>}
                                                </Fragment>
                                            }
                                            collapse={""}
                                            haveCollapse={false}
                                            action={() => handleOpen(rec)}
                                            actionName="Details"
                                            action2Name={rec?.isOpen ? "Fermer" : null}
                                            action2={() => handleCloseReceiving(rec.id)}
                                            isLoading={isLoading}
                                        />
                                    </Grid>
                                })
                                }
                            </Grid>
                        </Grid>
                    </AccordionDetails>
                </Accordion>
            </Stack>
        </Grid>
    )
}

export default ReceivedGroup;